const mutations = {
  SET_TYPES( state, payload ) {
    let types = payload;

    state.types = types;
  },
};

export default mutations;
